import { Params } from "../interface/core.interface";

export class GetCategoriesAction {
  static readonly type = "[Category] Get";
}

export class GetLayerdCategoriesWithProductsAction {
  static readonly type = "[Category] Layerd Categories With Products Get";
}
